import React, { createContext, useContext, useState } from "react";

export type PortfolioFormValidationContextType = {
  validationState: { [key: string]: boolean };
  isFormValid: () => boolean;
  resetValidationState: () => void;
  updateValidationState: (field: string, isValid: boolean) => void;
};

export const PortfolioFormValidationContext = createContext<
  PortfolioFormValidationContextType | undefined
>(undefined);

export const usePortfolioFormValidation = () => {
  const context = useContext(PortfolioFormValidationContext);

  if (!context)
    throw new Error(
      "usePortfolioFormValidation must be used within a PortfolioFormValidationProvider"
    );

  return context;
};

interface PortfolioFormValidationProviderProps {
  children: React.ReactNode;
}

export const PortfolioFormValidationProvider: React.FC<
  PortfolioFormValidationProviderProps
> = ({ children }) => {
  const [validationState, setValidationState] = useState<{
    [key: string]: boolean;
  }>({});

  const isFormValid = () => {
    return Object.values(validationState).every((isValid) => isValid);
  };
  const resetValidationState = () => {
    setValidationState({});
  };
  const updateValidationState = (field: string, isValid: boolean) => {
    setValidationState((prevState) => ({
      ...prevState,
      [field]: isValid,
    }));
  };

  return (
    <PortfolioFormValidationContext.Provider
      value={{
        validationState,
        isFormValid,
        resetValidationState,
        updateValidationState,
      }}
    >
      {children}
    </PortfolioFormValidationContext.Provider>
  );
};
